module.exports = __webpack_public_path__ + "static/media/mail-blue-dark.54641486.svg";